import { useEffect, useMemo, useState } from 'react';
import { returnContainerPointsListener } from '~/firebase/listeners/platform';
import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { ReturnContainerPointWithId } from '~/types/platform/returnContainerPoint';

import platformAtom from '~/recoil/atom/platform';

import { PLATFORM_ID } from '~/globalVariables';
import { useRecoilValue } from 'recoil';

export default function useReturnContainerPoints() {
  const platform = useRecoilValue(platformAtom);

  const [returnContainerPoints, setReturnContainerPoints] = useState<
    Array<ReturnContainerPointWithId>
  >([]);

  const handleSetReturnContainerPoints: CollectionSnapShotFn = (snap) => {
    const newReturnPoints: Array<ReturnContainerPointWithId> = [];
    snap.forEach((doc) => {
      newReturnPoints.push({ ...doc.data(), id: doc.id } as ReturnContainerPointWithId);
    });
    setReturnContainerPoints(newReturnPoints);
  };

  useEffect(() => {
    const unlisten = returnContainerPointsListener(PLATFORM_ID, handleSetReturnContainerPoints);
    return () => {
      unlisten();
    };
  }, []);

  const displayReturnContainerPoints = useMemo(() => {
    return returnContainerPoints.filter((returnContainerPoint) =>
      platform.returnContainerPoints.includes(returnContainerPoint.id),
    );
  }, [returnContainerPoints, platform]);

  return displayReturnContainerPoints;
}
